// Get backend service name from environment variable
// UAT: dayli-backend-service
// PROD: dayli-backend-service-prod
// Note: Create React App injects REACT_APP_* variables at build time
const getBackendServiceName = (): string => {
  // Read from environment variable - Create React App injects these at build time
  const serviceName = process.env.REACT_APP_BACKEND_SERVICE_NAME;
  
  // Debug logging (will be removed in production builds by minification)
  if (process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG) {
    console.log('🔍 Environment check:', {
      'REACT_APP_BACKEND_SERVICE_NAME': serviceName,
      'NODE_ENV': process.env.NODE_ENV,
      'All REACT_APP_ vars': Object.keys(process.env).filter(k => k.startsWith('REACT_APP_'))
    });
  }
  
  if (serviceName) {
    return serviceName;
  }
  // Default to UAT if not set
  console.warn('⚠️ REACT_APP_BACKEND_SERVICE_NAME not found, defaulting to dayli-backend-service');
  return 'dayli-backend-service';
};

// Evaluate backend service name at module load time (build time)
// This ensures the correct value is used based on the .env file during build
const backendServiceName = getBackendServiceName();

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api-uat.sparrowcard.com',
  BACKEND_SERVICE_NAME: backendServiceName,
  ENDPOINTS: {
    INSTITUTIONS: `/${backendServiceName}/productId/dayli/institutions/`,
  },
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
} as const;

// Request Headers
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
} as const;

// Environment-based configuration
export const getApiConfig = () => {
  return API_CONFIG;
};

// Helper function to build API endpoints with backend service name
export const buildApiEndpoint = (path: string): string => {
  const backendService = getBackendServiceName();
  // Remove leading slash if present, we'll add it
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `/${backendService}/productId/dayli/${cleanPath}`;
};
